import IconUsFlag from '@/components/icons/us-flag';
import IconVnFlag from '@/components/icons/vn-flag';
const appConfig = {
  title: 'Corodomo',
  description: 'The best focus timer and productivity tool',
  email: 'support@corodomo.com',
  mainEmail: 'corodomo@corodomo.com',
  plusEmail: 'plus@corodomo.com',
  notificationEmail: 'notification.corodomo@gmail.com',
  discordUrl: 'https://discord.gg/Na8BkmKNZw',
  facebookFanpage: 'https://www.facebook.com/corodomo',
  facebookGroupUrl: 'https://www.facebook.com/corodomo',
  facebookVnGroupUrl: 'https://www.facebook.com/groups/441834957370096',
  feedbackUrl: 'https://corodomo.features.vote/board',
  x: 'https://x.com/corodomo_study',
  linkedinUrl: 'https://www.linkedin.com/in/rem-dev/',
  facebookAppId: '972560901465645',
  monthlyPrice: 2,
  yearlyPrice: 12,
  vndMonthlyPrice: 150000,
  vndYearlyPrice: 99000,
  usdMonthlyPrice: 6,
  usdYearlyPrice: 3.96,
  vndDiscountPrice: 125000,
  usdDiscountPrice: 5,
  discountCode33: 'CORONEW',
  monthlyName: 'Monthly',
  yearlyName: 'Yearly'
};
export const appLanguages = [{
  name: 'Vietnamese (vi-VN)',
  label: 'VN',
  value: 'vi',
  icon: <IconVnFlag width={18} />
}, {
  name: 'English (en-US)',
  label: 'EN',
  value: 'en',
  icon: <IconUsFlag width={18} />
}];
export default appConfig;